import React from 'react'
import moment from 'moment'
import _ from 'lodash'
import { Checkbox, Tooltip } from 'antd'
import { Icon, Div } from 'konsys-ui'
import { ChevronsUpDown } from 'lucide-react'
import {
  status as shippingStatus, statusText, fuelStatus, fuelStatusText,
} from '../constants'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText, DropdownSelector,
} from '../../../components/shipping-order-components'
import { theme } from '../../../styles/_variables'

const { color } = theme

export const textStatusSelector = (status) => {
  switch (status) {
    case shippingStatus.WAITING:
      return statusText.WAITING
    case shippingStatus.ASSIGNED:
      return statusText.ASSIGNED
    case shippingStatus.PICKEDUP:
      return statusText.PICKEDUP
    case shippingStatus.EXPIRED:
      return statusText.EXPIRED
    case shippingStatus.DELIVERED:
      return statusText.DELIVERED
    case shippingStatus.CANCELLED:
      return statusText.CANCELLED
    case shippingStatus.BILLED:
      return statusText.BILLED
    default:
      return 'ไม่ได้ระบุ'
  }
}

export const colorSelector = (status) => {
  switch (status) {
    case shippingStatus.WAITING:
      return '#97A0AF'
    case shippingStatus.ASSIGNED:
      return '#00B8D9'
    case shippingStatus.PICKEDUP:
      return '#FF9920'
    case shippingStatus.EXPIRED:
      return '#FF6542'
    case shippingStatus.DELIVERED:
      return '#38B47F'
    case shippingStatus.CANCELLED:
      return '#FF5B37'
    case shippingStatus.BILLED:
      return '#00B8D9'
    default:
      return '#333'
  }
}

const textFuelStatusSelector = (status) => {
  switch (status) {
    case fuelStatus.NONE:
      return fuelStatusText.NONE
    case fuelStatus.WAITING:
      return fuelStatusText.WAITING
    case fuelStatus.EXPIRED:
      return fuelStatusText.EXPIRED
    case fuelStatus.FILLED:
      return fuelStatusText.FILLED
    case fuelStatus.BILLED:
      return fuelStatusText.BILLED
    case fuelStatus.CANCELLED:
      return fuelStatusText.CANCELLED
    case fuelStatus.LOST:
      return fuelStatusText.LOST
    default:
      return 'ไม่ได้ระบุ'
  }
}

const fuelColorSelector = (status) => {
  switch (status) {
    case fuelStatus.NONE:
      return '#172B4D'
    case fuelStatus.WAITING:
      return '#97A0AF'
    case fuelStatus.EXPIRED:
      return '#FF6542'
    case fuelStatus.FILLED:
      return '#38B47F'
    case fuelStatus.BILLED:
      return '#00B8D9'
    case fuelStatus.CANCELLED:
      return '#FF5B37'
    case fuelStatus.LOST:
      return '#FF5630'
    default:
      return '#333'
  }
}

export default {
  columns: [{
    accessor: 'checkbox',
    filterable: true,
    sortable: false,
    Cell: props => (
    <Checkbox
      disabled={props.tdProps.rest.checkDisabled}
      key={props.value}
      checked={_.includes(props.tdProps.rest.check, props.original.id)}
      onChange={(e) => {
        if (e.target.checked) {
          props.tdProps.rest.setCheck(_.concat(props.tdProps.rest.check, props.original.id))
          props.tdProps.rest.setShippingOrders(_.concat(props.tdProps.rest.shippingOrders, props.original))
        } else {
          props.tdProps.rest.setCheck(_.remove(_.cloneDeep(props.tdProps.rest.check), n => n !== props.original.id))
          props.tdProps.rest.setShippingOrders(_.remove(_.cloneDeep(props.tdProps.rest.shippingOrders), n => n.id !== props.original.id))
        }
      }}
    />
    ),
    width: 80,
    Header: (props, y) => (
        <Div display='flex' justifyContent='space-between' alignItems='center'>
          <HeaderLabel>
            เล่มที่ <ChevronsUpDown color={color.coolGrey} />
          </HeaderLabel>
        </Div>
    ),
    Filter: props => (
        <Div display='flex' justifyContent='space-between'>
          <Checkbox
            style={{ paddingLeft: 3 }}
            // checked={isCheckAll}
            // disabled={checkDisabled}
            onChange={(e) => {
              props.onChange(e)
            }}
          />
        </Div>
    ),
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          เล่มที่ <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'shippingVolume',
    sortable: true,
    filterable: true,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.id, filter.value),
    width: 80,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          เลขที่ <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'shippingNumber',
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.createdDate, filter.value),
    sortable: true,
    filterable: true,
    width: 80,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          วันที่ครบกำหนด <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'assignDate',
    sortable: true,
    filterable: false,
    Cell: props => <CellText>{moment(props.value).format('DD/MM/YYYY')}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.clientId, filter.value),
    width: 120,
  }, {
    Header: <HeaderLabel>สาขา</HeaderLabel>,
    accessor: 'Customer.branch',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.clientName, filter.value),
    width: 140,
  }, {
    Header: <HeaderLabel>ผู้จ้าง</HeaderLabel>,
    accessor: 'Customer.companyName',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.from, filter.value),
    width: 160,
  }, {
    Header: <HeaderLabel>ทะเบียนรถ</HeaderLabel>,
    accessor: 'Truck.plateNumber',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.to, filter.value),
    width: 140,
  }, {
    Header: <HeaderLabel>ชื่อคนขับรถ</HeaderLabel>,
    accessor: 'Driver.fullname',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.Customer.typeOfCharge, filter.value),
    width: 140,
  }, {
    Header: <HeaderLabel>สถานะ</HeaderLabel>,
    accessor: 'status',
    sortable: false,
    filterable: true,
    Cell: props => <CellText color={colorSelector(props.value)} bold>{textStatusSelector(props.value)}</CellText>,
    Filter: ({ onChange }) => {
      const arr = [
        { value: shippingStatus.ALL, text: statusText.ALL },
        { value: shippingStatus.WAITING, text: statusText.WAITING },
        { value: shippingStatus.ASSIGNED, text: statusText.ASSIGNED },
        { value: shippingStatus.EXPIRED, text: statusText.EXPIRED },
        { value: shippingStatus.DELIVERED, text: statusText.DELIVERED },
        { value: shippingStatus.CANCELLED, text: statusText.CANCELLED },
        { value: shippingStatus.BILLED, text: statusText.BILLED },
      ]
      return (
        <DropdownSelector
          key='filter'
          data={arr}
          handleChange={e => onChange(e)}
          filter={true}
          statusAttr='ทั้งหมด'
        />
      )
    },
    width: 140,
  }, {
    Header: <HeaderLabel>สถานะน้ำมัน</HeaderLabel>,
    accessor: 'FuelOrder.status',
    sortable: false,
    filterable: true,
    Cell: props => <CellText color={fuelColorSelector(props.value)} bold>{textFuelStatusSelector(props.value)}</CellText>,
    Filter: ({ onChange }) => {
      const arr = [
        { value: fuelStatus.ALL, text: fuelStatusText.ALL },
        { value: fuelStatus.NONE, text: fuelStatusText.NONE },
        { value: fuelStatus.WAITING, text: fuelStatusText.WAITING },
        { value: fuelStatus.EXPIRED, text: fuelStatusText.EXPIRED },
        { value: fuelStatus.FILLED, text: fuelStatusText.FILLED },
        { value: fuelStatus.CANCELLED, text: fuelStatusText.CANCELLED },
        { value: fuelStatus.BILLED, text: fuelStatusText.BILLED },
        { value: fuelStatus.LOST, text: fuelStatusText.LOST },
      ]
      return (
          <DropdownSelector
            key='filter'
            data={arr}
            handleChange={e => onChange(e)}
            filter={true}
            statusAttr='ทั้งหมด'
          />
      )
    },
    width: 140,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    // Cell: props => <ActionSelector disabled={props.tdProps.rest.disabled} />,
    Cell: props => <ActionSelector props={props} key={props.original.id} refetch={props.tdProps.rest.refetch}/>,
    width: 150,
  }],
}
